/**
 * Review Appeal Service
 * Handles review appeals/arbitration for all roles
 */

import api from './api';

const reviewAppealService = {

  fileAppeal: async (appealData) => {
    try {
      const response = await api.post('/review-appeals', appealData);
      return response.data;
    } catch (error) {
      console.error('File appeal error:', error);
      throw new Error(error.response?.data?.message || error.message || 'Failed to file appeal');
    }
  },

  getMyAppeals: async () => {
    try {
      const response = await api.get('/review-appeals/my-appeals');
      return response.data;
    } catch (error) {
      console.error('Get my appeals error:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch appeals');
    }
  },

  getAppeal: async (appealId) => {
    try {
      const response = await api.get(`/review-appeals/${appealId}`);
      return response.data;
    } catch (error) {
      console.error('Get appeal error:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch appeal details');
    }
  },

  addEvidence: async (appealId, evidenceData) => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/evidence`, evidenceData);
      return response.data;
    } catch (error) {
      console.error('Add evidence error:', error);
      throw new Error(error.response?.data?.message || 'Failed to add evidence');
    }
  },

  sendMessage: async (appealId, message, messageType = 'message') => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/message`, { message, messageType });
      return response.data;
    } catch (error) {
      console.error('Send message error:', error);
      throw new Error(error.response?.data?.message || 'Failed to send message');
    }
  },

  withdrawAppeal: async (appealId, reason) => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/withdraw`, { reason });
      return response.data;
    } catch (error) {
      console.error('Withdraw appeal error:', error);
      throw new Error(error.response?.data?.message || 'Failed to withdraw appeal');
    }
  },

  getAllAppeals: async (params = {}) => {
    try {
      const { status, page = 1, limit = 20, urgentOnly = false } = params;
      const response = await api.get('/review-appeals/admin/all', {
        params: { status, page, limit, urgentOnly }
      });
      return response.data;
    } catch (error) {
      console.error('Get all appeals error:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch appeals');
    }
  },

  getAppealStats: async () => {
    try {
      const response = await api.get('/review-appeals/admin/stats');
      return response.data;
    } catch (error) {
      console.error('Get appeal stats error:', error);
      throw new Error(error.response?.data?.message || 'Failed to fetch appeal statistics');
    }
  },

  addInternalNote: async (appealId, message) => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/internal-note`, { message });
      return response.data;
    } catch (error) {
      console.error('Add internal note error:', error);
      throw new Error(error.response?.data?.message || 'Failed to add internal note');
    }
  },

  resolveAppeal: async (appealId, resolutionData) => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/resolve`, resolutionData);
      return response.data;
    } catch (error) {
      console.error('Resolve appeal error:', error);
      throw new Error(error.response?.data?.message || 'Failed to resolve appeal');
    }
  },

  scheduleMediation: async (appealId, mediationData) => {
    try {
      const response = await api.post(`/review-appeals/${appealId}/schedule-mediation`, mediationData);
      return response.data;
    } catch (error) {
      console.error('Schedule mediation error:', error);
      throw new Error(error.response?.data?.message || 'Failed to schedule mediation');
    }
  }
};

export default reviewAppealService;
